/* eslint-disable no-nested-ternary */
import {
  Button,
  Col,
  Input,
  Label,
  Row,
  TabPane,
  FormGroup,
  FormText,
  Card,
  CardBody,
  FormFeedback,
} from 'reactstrap';
import { FiFileText } from 'react-icons/fi';
import { IoIosCloudDone, IoIosCloudUpload } from 'react-icons/io';
import { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { RiArrowDropLeftLine, RiArrowDropRightLine } from 'react-icons/ri';
import { toastError } from '@src/utility/Toast';
import * as Yup from 'yup';
import { useAuthOnboarding } from '@src/utility/hooks/useAuthOnboarding';
import { useLoadingGlobal } from '@src/utility/hooks/useLoadingGlobal';
import apiOnboarding from '@src/services/api-onboarding';
import api from '@src/services/api';
import { toast } from 'react-toastify';
import { cpfMask, rgMask } from '@src/utility/Mask';

interface Finances {
  monthlyInvoicing: string;
  shareCapital?: string;
  patrimony?: string;
}

interface OtherInfoInterface {
  marital?: string;
  education?: string;
  rg?: string;
  rgIssuer?: string;
  rgIssuedDate?: string;
  softwareDescriptor?: string;
}

interface OIdata {
  idOperator: string;
  finances: Finances;
  otherInfo?: OtherInfoInterface;
  document: string;
}
interface OtherInfoProps {
  handleChangeTabe: (tab: string) => void;
  request?: Record<string, unknown>;
  otherInfoDataChange: (data: OIdata) => void;
}

const OtherInfo: React.FC<OtherInfoProps> = ({
  handleChangeTabe,
  request,
  otherInfoDataChange,
}) => {
  const [data, setData] = useState<any>(null);
  const { verifyLogin } = useAuthOnboarding();
  const { showLoader, hideLoader } = useLoadingGlobal();
  const [idOperator, setIdOperator] = useState('');
  const [document, setDocument] = useState('');
  const [monthlyInvoicing, setMonthlyInvoicing] = useState('');
  const [shareCapital, setShareCapital] = useState('');
  const [patrimony, setPatrimony] = useState('');
  const [marital, setMarital] = useState('');
  const [education, setEducation] = useState('');
  const [rg, setRg] = useState('');
  const [rgIssuer, setRgIssuer] = useState('');
  const [rgIssuedDate, setRgIssuedDate] = useState('');
  const [rgIssuedDateError, setRgIssuedDateError] = useState('');
  const [softwareDescriptor, setSoftwareDescriptor] = useState('');
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const filterMaskedValue = (value: string) => {
    const filteredValue = value.replace(/[R$,.]/g, '');
    return filteredValue.trim();
  };

  const handleSubmit = async () => {
    const filteredMonthlyInvoicing = filterMaskedValue(monthlyInvoicing);
    const filteredShareCapital = filterMaskedValue(shareCapital);
    const filteredPatrimony = filterMaskedValue(patrimony);

    const formData: OIdata = {
      idOperator: request?.idOperator as string,
      finances: {
        monthlyInvoicing: filteredMonthlyInvoicing,
      },
      document: document.replace(/[.-]/g, ''),
    };

    if (request?.type === 'cnpj') {
      formData.finances.shareCapital = filteredShareCapital;
      formData.finances.patrimony = filteredPatrimony;
      formData.otherInfo = {
        rg: rg.replace(/[.-]/g, ''),
        rgIssuer,
        rgIssuedDate,
        softwareDescriptor,
      };
    }
    if (request?.type === 'cpf') {
      formData.otherInfo = {
        marital,
        education,
        rg: rg.replace(/[.-]/g, ''),
        rgIssuer,
        rgIssuedDate,
      };
    }
    otherInfoDataChange(formData);
    handleChangeTabe('9');

    //   apiOnboarding
    //     .post('api/company-caf/send-aditional-info', formData, {
    //       headers: { 'Content-Type': 'application/json' },
    //     })
    //     .then(() => {
    //       handleChangeTabe('9');
    //     })
    //     .catch((error) => {
    //       toastError({
    //         title: 'Erro',
    //         description: 'Erro ao enviar dados, por favor tente novamente',
    //       });
    //     });
  };
  const isButtonDisabled = () => {
    if (request?.type === 'cpf') {
      return (
        !monthlyInvoicing ||
        !marital ||
        !education ||
        rg.length < 9 ||
        !rgIssuer ||
        !rgIssuedDate ||
        rgIssuedDateError.length > 0 ||
        !softwareDescriptor ||
        document.length < 14
      );
    }
    return (
      !monthlyInvoicing ||
      rg.length < 9 ||
      !rgIssuer ||
      !rgIssuedDate ||
      rgIssuedDateError.length > 0 ||
      !shareCapital ||
      !patrimony ||
      !softwareDescriptor ||
      document.length < 14
    );
  };
  const handleInputChange =
    (setter: React.Dispatch<React.SetStateAction<string>>) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let { value } = e.target;
      value = value.replace(/\D/g, '');
      value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (value !== '') value = `$${value}`;
      setter(value);
    };

  const handleMakeMonthlyInvoicing = (value: string) => {
    setMonthlyInvoicing(maskCoin(value));
  };

  const handleMakeShareCapital = (value: string) => {
    setShareCapital(maskCoin(value));
  };

  const handleMakePatrimony = (value: string) => {
    setPatrimony(maskCoin(value));
  };

  const handleRgIssuedDate = (e: any) => {
    const [year, month, day] = e.target.value.split('-').map(Number);
    const selectedDate = new Date(year, month - 1, day);
    selectedDate.setHours(0, 0, 0, 0);

    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 10);
    minDate.setHours(0, 0, 0, 0);

    if (selectedDate < minDate) {
      setRgIssuedDateError(
        '* A Data de Emissão do RG não pode ser menor que 10 anos atrás.'
      );
    } else {
      setRgIssuedDateError('');
    }

    setRgIssuedDate(e.target.value);
  };

  const maskCoin = (value: string) => {
    if (value === null || value === '') {
      return '';
    }

    const onlyDigits = value
      .split('')
      .filter((s: string) => /\d/.test(s))
      .join('')
      .padStart(3, '0');
    const digitsFloat = `${onlyDigits.slice(0, -2)}.${onlyDigits.slice(-2)}`;
    return maskCurrency(digitsFloat);
  };

  const maskCurrency = (value: string, locale = 'pt-BR', currency = 'BRL') => {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(Number(value));
  };

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    setData(JSON.parse(localStorage.getItem('userData') as string));
  }, [request]);

  return (
    <TabPane tabId="8">
      <FormGroup>
        <Label for="document">CPF</Label>
        <FormText color="muted">
          {request?.type === 'cpf'
            ? 'CPF pertencente ao representante'
            : 'CPF pertencente ao representante legal da empresa'}
        </FormText>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Input
            type="text"
            maxLength={14}
            minLength={14}
            id="document"
            placeholder="000.000.000-00"
            value={document}
            onChange={(e) => {
              setDocument(cpfMask.mask(e.target.value));
            }}
          />
        </div>
      </FormGroup>

      <FormGroup>
        <Label for="rg">
          RG <span>(apenas números e letras)</span>
        </Label>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Input
            type="text"
            maxLength={12}
            minLength={12}
            id="rg"
            placeholder="00.000.000-0"
            value={rg}
            onChange={(e) => {
              setRg(e.target.value);
            }}
          />
        </div>
      </FormGroup>

      <FormGroup>
        <Label for="rgIssuer">Órgão Emissor do RG</Label>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Input
            type="text"
            maxLength={30}
            minLength={3}
            id="rgIssuer"
            placeholder="DETRAN"
            value={rgIssuer}
            onChange={(e) => setRgIssuer(e.target.value)}
          />
        </div>
      </FormGroup>

      <FormGroup>
        <Label for="rgIssuedDate">Data de Emissão</Label>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Input
            type="date"
            id="rgIssuedDate"
            value={rgIssuedDate}
            max={getCurrentDate()}
            onChange={(e) => handleRgIssuedDate(e)}
          />

          {rgIssuedDateError && rgIssuedDateError.length > 0 ? (
            <span className="text-danger ml-2">{rgIssuedDateError}</span>
          ) : null}
        </div>
      </FormGroup>

      <hr />
      <FormGroup>
        <Label for="monthlyInvoicing">Faturamento Mensal</Label>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Input
            type="text"
            maxLength={15}
            id="monthlyInvoicing"
            placeholder="R$ 0,00"
            value={monthlyInvoicing}
            onChange={(e) => handleMakeMonthlyInvoicing(e?.target?.value)}
          />
        </div>
      </FormGroup>

      <FormGroup>
        <Label for="softwareDescriptor">Soft Descriptor</Label>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Input
            type="text"
            maxLength={30}
            minLength={1}
            id="softwareDescriptor"
            placeholder="ULTRAPAY"
            value={softwareDescriptor}
            onChange={(e) => setSoftwareDescriptor(e.target.value)}
            title="O soft-descriptor é um texto adicional que será apresentado junto ao nome do estabelecimento na fatura"
          />
        </div>
      </FormGroup>

      {request?.type === 'cnpj' && (
        <>
          <FormGroup>
            <Label for="shareCapital">Capital Social</Label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Input
                type="text"
                maxLength={15}
                id="shareCapital"
                placeholder="R$ 0,00"
                value={shareCapital}
                onChange={(e) => handleMakeShareCapital(e?.target?.value)}
              />
            </div>
          </FormGroup>

          <FormGroup>
            <Label for="patrimony">Patrimônio</Label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Input
                type="text"
                maxLength={15}
                id="patrimony"
                placeholder="R$ 0,00"
                value={patrimony}
                onChange={(e) => handleMakePatrimony(e?.target?.value)}
              />
            </div>
          </FormGroup>
        </>
      )}
      {request?.type === 'cpf' && (
        <>
          <FormGroup>
            <Label for="maritalStatus">Estado Civil</Label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Input
                type="select"
                name="maritalStatus"
                id="maritalStatus"
                value={marital}
                onChange={(e) => setMarital(e.target.value)}
              >
                <option value="">Selecione o estado civil</option>
                <option value="SINGLE">Solteiro</option>
                <option value="MARRIED">Casado</option>
                <option value="LEGALLY_SEPARATED">Legalmente Separado</option>
                <option value="DIVORCED">Divorciado</option>
                <option value="STABLE_UNION">União Estável</option>
                <option value="DETACHED">Separado</option>
                <option value="WIDOWER">Viúvo</option>
              </Input>
            </div>
          </FormGroup>

          <FormGroup>
            <Label for="educationLevel">Nível de Educação</Label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Input
                type="select"
                name="educationLevel"
                id="educationLevel"
                value={education}
                onChange={(e) => setEducation(e.target.value)}
              >
                <option value="">Selecione o nível de educação</option>
                <option value="ILLITERATE">Analfabeto</option>
                <option value="ELEMENTARY_1_TO_4_YEAR">
                  Fundamental 1 a 4 Ano
                </option>
                <option value="ELEMENTARY_5_YEAR">Fundamental 5 Ano</option>
                <option value="ELEMENTARY_6_TO_8_YEAR">
                  Fundamental 6 a 8 Ano
                </option>
                <option value="COMPLETE_ELEMENTARY">
                  Fundamental Completo
                </option>
                <option value="INCOMPLETE_HIGH_SCHOOL">
                  Ensino Médio Incompleto
                </option>
                <option value="COMPLETE_HIGH_SCHOOL">
                  Ensino Médio Completo
                </option>
                <option value="INCOMPLETE_HIGHER">
                  Ensino Superior Incompleto
                </option>
                <option value="COMPLETE_HIGHER">
                  Ensino Superior Completo
                </option>
                <option value="POSTGRADUATE">Pós-Graduado</option>
                <option value="MASTER_DEGREE">Mestrado</option>
                <option value="DOCTORATE_DEGREE">Doutorado</option>
              </Input>
            </div>
          </FormGroup>
        </>
      )}
      <Row>
        <Col className="d-flex justify-content-between">
          <Button
            size="sm"
            onClick={() => handleChangeTabe('7')}
            color="secondary"
          >
            <RiArrowDropLeftLine size={25} /> Anterior
          </Button>
          <Button
            style={{ cursor: !isButtonDisabled() ? 'pointer' : 'not-allowed' }}
            color={`${!isButtonDisabled() ? 'success' : 'secondary'}`}
            onClick={() => handleSubmit()}
            disabled={isButtonDisabled()}
          >
            Próximo
          </Button>
        </Col>
      </Row>
    </TabPane>
  );
};

export default OtherInfo;
